exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xm-sidebar[data-v-5a835254]{position:fixed;top:66px;z-index:29;width:200px;height:calc(100vh - 66px);margin-left:-200px;border-right:1px solid #b6b6b6;background:#fff}.xm-sidebar a[data-v-5a835254]{display:block;padding:0 20px;font-size:14px;line-height:40px;color:#444}.xm-sidebar a[data-v-5a835254]:hover{background-color:#f0f0f0;text-decoration:none!important}.xm-sidebar a.router-link-active[data-v-5a835254]{color:#0884f3;background:#ecf4fd}", ""]);

// exports
